import { getIncomes, getPageIncomes, getStockProducts } from '../../api/endpoints/incomes';

export const state = {
  data: [],
  currentPage: 1,
  rows: 1,
  perPage: 1,
  stockProducts: [],
}

export const getters = {
  tableData: s => s.data,
  currentPage: s => s.currentPage,
  rows: s => s.rows,
  perPage: s => s.perPage
}

export const mutations = {
  GET_ROWS(state) {
    getIncomes().then( res => {
      state.rows = res.data.total
    })
  },
  GET_PER_PAGE(state) {
    getIncomes().then( res => {
      state.perPage = res.data.per_page
    })
  },
  GET_COUNT(state, id) {
    state.currentPage = id;
    getPageIncomes(state.currentPage).then( res => {
      state.data = res.data.data
    })
  },
  GET_DATA(state) {
    getPageIncomes(state.currentPage).then( res => {
      state.data = res.data.data
    })
  },
  SET_STOCK_PRODUCTS(state, payload) {
    state.stockProducts = payload;
  }
}

export const actions = {
  getRows({commit}) {
    commit('GET_ROWS')
  },
  getPerPage({commit}) {
    commit('GET_PER_PAGE')
  },
  getCount({commit}, params) {
    commit('GET_COUNT', params)
  },
  getData({commit}) {
    commit('GET_DATA')
  },
  getStockProducts({commit}) {
    return new Promise(resolve => {
      getStockProducts().then(res => {
        commit('SET_STOCK_PRODUCTS',res.data.data);
        resolve(res)
      })
    })
  }
}
